module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9b9-1f3fd-200d-2642-fe0f.f4496b6d.svg";